const selectSelfAssessments = (state) => state.selfAssessments;
export const selectSelfAssessmentsData = (state) => selectSelfAssessments(state).data;
export const selectSelfAssessmentsTotal = (state) => selectSelfAssessments(state).total;
